export default "__VITE_ASSET__CK$qjIeI__"